import { Outlet, useLoaderData, useRouteLoaderData } from '@remix-run/react';

import { REPUBS } from '@cx-modules/constants';

import Breadcrumbs from '~/components/Breadcrumbs';
import { StandardLayout } from '~/layouts/StandardLayout';
import type { loader as rootLoader } from '~/root-loader';

import type { loader } from './loader';

export { loader } from './loader';

export default function OffersPage() {
	const rootLoaderData = useRouteLoaderData<typeof rootLoader>('root');
	if (!rootLoaderData) {
		throw new Error('Root loader data is missing');
	}

	const data = useLoaderData<typeof loader>();

	/* NOTE: we've removed StandardLayout wrapper here
	to allow testing of headless render on OC repub,
	however if we want to render full pages we need
	to ensure ServicesProvider wrapper is rendered
	in StandardLayout, i.e. not short-circuited */
	if (rootLoaderData.repub === REPUBS.OC.name) {
		return (
			<div>
				<div
					style={{
						backgroundColor: 'red',
						textAlign: 'center',
						padding: '16px',
					}}
				>
					<i>
						This view is for testing OffersList without StandardLayout wrappers,
						i.e. Header, Breadcrumbs, Footer etc.
					</i>
				</div>
				<Outlet context={data} />;
			</div>
		);
	}

	return (
		<StandardLayout {...rootLoaderData} {...data}>
			<Outlet context={data} />
			<Breadcrumbs />
		</StandardLayout>
	);
}
